export default "__VITE_ASSET__CWj5gq$M__"